// extracted by mini-css-extract-plugin
module.exports = {"gw_quote_coverable_subtable":"defaultVehicleCoverages-hashed__gw_quote_coverable_subtable__3X2kI"};